__turbopack_context__.v({
  "searchInput": "search-input-module-scss-module__FyJL_q__searchInput",
});
